/**
 * Plan type primitives for the subscription-plan model.
 */

/**
 * Stable plan identifier: the in-app `trial` plus the three escalating paid
 * tiers (`trade_basic` < `trade_execution` < `trade_discovery`).
 * Widenable union: new ids can be added here later without reworking
 * enforcement, which resolves every id through the same path.
 */
export type PlanId = 'trial' | 'trade_basic' | 'trade_execution' | 'trade_discovery';

/** A paid tier: the {@link PlanId} subset excluding `trial`. */
export type Tier = 'trade_basic' | 'trade_execution' | 'trade_discovery';

/** Billing cadence for a paid tier. */
export type Cadence = 'monthly' | 'annual';

/** Sentinel for an uncapped position limit. */
export const UNLIMITED = 'unlimited' as const;

/** The type of the {@link UNLIMITED} sentinel. */
export type Unlimited = typeof UNLIMITED;

/** A resolved maximum: a finite non-negative integer, or unlimited. */
export type MaxPositionsLimit = number | Unlimited;
/**
 * At_Or_Over_Limit predicate (shared by backend enforcement and frontend
 * fail-fast UI so they agree): an unlimited effective limit is never at/over;
 * a finite limit `L` is reached when `positionsCreated >= L`.
 */
export function isAtOrOverLimit(
  effectiveLimit: MaxPositionsLimit,
  positionsCreated: number,
): boolean {
  if (effectiveLimit === UNLIMITED) {
    return false;
  }
  return positionsCreated >= effectiveLimit;
}